import React, { useRef, useEffect, useState } from 'react';

interface ImagePickerProps {
  onChange: any,
  value: any,
}

function ImagePicker({
  onChange, value,
}: ImagePickerProps) {
  const inputFile = useRef(null);
  const [base64, setBase64] = useState(null);

  useEffect(() => {
    if (value) {
      const reader = new FileReader();
      reader.readAsDataURL(value);
      reader.onload = function() {
        // @ts-ignore
        if (reader.result) setBase64(reader.result);
      }
    }
  }, [value]);

  const handleClick = () => {
    // @ts-ignore
    inputFile.current.click()
  }

  const handleChange = (file: any) => {
    if(onChange) onChange(file.target.files ? file.target.files[0] : null);
  };

  return (
    <div className="component-image-picker" onClick={() => handleClick()}>
      {
        base64 ? (
          // @ts-ignore
          <img src={base64} />
        ) : '✚'
      }
      <input
        ref={inputFile}
        type="file"
        onChange={file => handleChange(file)}
      />
    </div>
  );
}

export default ImagePicker;

ImagePicker.defaultProps = {
  onChange: null,
  value: null,
}
